import { forwardRef, useMemo } from 'react';
import { Box } from './Box';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';
import { Banner } from './Banner';
import { pipe } from 'fp-ts/lib/function';
import { fromPredicate, getOrElseW, map } from 'fp-ts/lib/Option';
import { hasError } from './utils/error';

type InputErrorTypeMap = BaseTypeMap<
  'div',
  { id: string; error?: string | string[] }
>;

export type InputErrorProps = ComponentProps<InputErrorTypeMap>;

const color: any = 'negative'; //TODO: fix typing of color in banner

export const InputError: Component<InputErrorTypeMap> = forwardRef(
  function InputError({ children, className, id, error, ...rest }, ref) {
    const errors = useMemo(
      () =>
        pipe(
          error,
          fromPredicate(hasError),
          map((err) => (Array.isArray(err) ? err : [err])),
          map((errs) =>
            errs.map((err, i) => (
              <Box as="li" key={i}>
                {err}
              </Box>
            ))
          ),
          getOrElseW(() => undefined)
        ),
      [error]
    );

    if (!errors) {
      return null;
    }

    return (
      <Banner ref={ref} id={id} arrow color={color} {...rest}>
        <Box as="ul" className="list-none">
          {errors}
        </Box>
      </Banner>
    );
  }
);
